<template>
  <div class="editor">
    <div class="meta-header">
      <AppModalProfileAvatar :key="user?.imageUrl" class="meta-avatar" :user="user" is-portrait />
      <AppModalProfileMeta />
    </div>
    <div class="card">
      <AppModalProfileRichTextEditor
        v-model="testimonialText"
        v-model:text-length="testimonialTextLength"
        edit-label="Click to Edit Your Testimonial"
        :is-editing="isTestimonialEditing"
        :max-length="800"
        :placeholder="PLACEHOLDER"
        :disabled="isLoading || isSaving"
        @start="startTestimonialEditing"
        @cancel="discardTestimonialEdits"
      />
    </div>
  </div>
</template>

<script setup>
import AppModalProfileAvatar from "@/components/App/Modal/Profile/Avatar";
import AppModalProfileMeta from "@/components/App/Modal/Profile/ProfileMeta";
import AppModalProfileRichTextEditor from "@/components/App/Modal/Profile/RichTextEditor";
import {useProfileContent} from "@/composables/useProfileContent";
import useUserSafe from "@/composables/useUserSafe";

const {
  testimonialText, testimonialTextLength, isLoading, isSaving, isTestimonialEditing,
  startTestimonialEditing, discardTestimonialEdits
} = useProfileContent();
const {user} = useUserSafe();
const PLACEHOLDER = "What did you value most about VIZBI that others should discover?\n\n" +
  "Write in the first person, max 800 characters.";

defineExpose({focus: startTestimonialEditing});
</script>

<style scoped>
.editor {
  flex: 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding: 4px 0 3px; /* closer to the footer buttons */
}
/* the testimonial card takes the height left (index.vue .page.fills) */
.card {
  flex: 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
}
.card > .bio {
  flex: 1;
  min-height: 0;
}
.meta-header {
  display: flex;
  align-items: flex-start;
  gap: 10px;
}
/* as tall as the name and affiliation lines (ProfileMeta: line-heights 1.2 and 1.3, 1px gap), so
   their tops and bottoms meet; the width follows the People thumbnails' 167:241 (isPortrait) */
.meta-avatar {
  width: auto;
  height: calc(18px * 1.2 + 1px + 16px * 1.3);
  flex-shrink: 0;
  border: 1px solid #ccc;
}
/* larger than the Public tab's, next to the photo: the name a step up, the affiliation two */
.meta-header :deep(.name) {
  font-size: 18px;
}
.meta-header :deep(.affiliation) {
  font-size: 16px;
}
</style>
